"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledDropdownLink = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
//
// properties
//
const config_1 = require("../../../assets/styles/config");
const activeClassName = 'nav-item-active';
exports.StyledDropdownLink = styled_components_1.default.div `
  align-items: center;
  border-radius: 3px;
  color: ${config_1.colors.white};
  display: flex;
  font: ${config_1.fontSizes.base} ${config_1.fontFamilies.primary};
  height: 35px;
  margin: 5px 15px;
  outline: none;
  padding: 5px 10px;
  &:hover,
  &:focus {
    background: ${config_1.colors.indigo};
    color: ${config_1.colors.white};
  }
  &.${activeClassName} {
    background: ${config_1.colors.blurple};
  }
`;
